
import React from 'react';
import { useNavigate } from 'react-router-dom';

const TermsConditions: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="mx-auto max-w-4xl py-12 px-6">
        <div className="mb-8 flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-black text-slate-900 tracking-tight mb-2">Terms & Conditions</h1>
            <p className="text-slate-500 font-medium italic text-sm">Effective Date: February 24, 2026</p>
          </div>
          <button
            onClick={() => navigate(-1)}
            className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-slate-500 shadow-sm border border-slate-200 hover:text-[#136bce] hover:border-[#136bce] transition-all group"
          >
            <span className="material-symbols-outlined transition-transform group-hover:-translate-x-0.5">arrow_back</span>
          </button>
        </div>

        <div className="prose prose-slate max-w-none bg-white rounded-2xl border border-slate-200 p-8 shadow-sm">
          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-800 mb-4 border-l-4 border-[#136bce] pl-3">Agreement to Terms</h2>
            <p className="text-slate-600 leading-relaxed">
              By accessing or using the QA MATE Inspect Pro mobile application or web dashboard, you agree to be bound by these Terms & Conditions. If you disagree with any part of the terms, you may not access the Service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-800 mb-4 border-l-4 border-[#136bce] pl-3">Account Responsibilities</h2>
            <p className="text-slate-600 mb-4">When you create an account with us, you must provide information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms.</p>
            <ul className="list-disc pl-5 space-y-2 text-slate-600">
              <li>You are responsible for safeguarding the password that you use to access the Service.</li>
              <li>You agree not to disclose your password to any third party.</li>
              <li>You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.</li>
            </ul>
          </section>

          <section className="mb-8 bg-red-50 p-6 rounded-xl border border-red-100 shadow-sm">
            <h2 className="text-xl font-bold text-red-800 mb-4 border-l-4 border-red-500 pl-3">Account Deletion & Data Removal</h2>
            <div className="space-y-4 text-slate-700">
              <p className="font-semibold">Users have the absolute right to terminate their relationship with the platform and request complete data removal.</p>
              <div className="bg-white p-5 rounded-lg border border-red-100">
                <ul className="list-disc pl-5 space-y-3 text-sm">
                  <li><strong>Immediate Deletion:</strong> Once a user initiates an account deletion from the mobile app or the dashboard, the account status is updated and all associated data is deleted <strong>immediately</strong>.</li>
                  <li><strong>Content Removal:</strong> Deletion includes, but is not limited to, all pending inspection actions, draft reports, completed reports linked to that specific user ID, and all personal profile information.</li>
                  <li><strong>No Data Retention:</strong> QA MATE Systems <strong>will not keep any data</strong> related to a specific user ID after account deletion. We maintain a zero-retention policy for deleted identities to ensure user privacy and data sovereignty.</li>
                  <li><strong>Irreversibility:</strong> Please be advised that once an account is deleted, it cannot be restored. All professional records associated with that ID will be lost permanently.</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-800 mb-4 border-l-4 border-[#136bce] pl-3">Mobile App Usage</h2>
            <p className="text-slate-600 leading-relaxed">
              The mobile application is designed for field inspections. Use of the mobile app requires a stable internet connection for data synchronization. Users are prohibited from using the app for any purpose other than professional textile quality assurance.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-800 mb-4 border-l-4 border-[#136bce] pl-3">Limitation of Liability</h2>
            <p className="text-slate-600 leading-relaxed">
              In no event shall QA MATE Systems, nor its directors, employees, partners, or agents, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, or other intangible losses.
            </p>
          </section>

          <div className="mt-12 flex justify-center">
            <button
              onClick={() => navigate(-1)}
              className="inline-flex items-center gap-2 rounded-lg bg-[#136bce] px-8 py-3 text-sm font-bold text-white shadow-lg shadow-blue-500/30 hover:bg-blue-700 transition-all transform active:scale-95"
            >
              <span className="material-symbols-outlined text-[20px]">check</span>
              I Understand
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
